import "./App.css";
import { SnackbarProvider } from "notistack";
import AppRouter from "./router/AppRouter";

function App() {
  return (
    <SnackbarProvider
      autoHideDuration={5000}
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <AppRouter />
    </SnackbarProvider>
  );
}

export default App;
